import {App} from './app/app.dative'
import '../styles/index.css'

new App({
    el: "#app"
})